import { useState, useEffect, useCallback } from 'react';

export function useIsMobileView() {
  const checkIsMobile = useCallback(() => {
    if (typeof window === 'undefined') return false;

    // Check if user explicitly requested full desktop mode on this device
    const isForcedDesktop = localStorage.getItem('trophycoin_force_desktop') === 'true';
    if (isForcedDesktop) return false;

    const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
    const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const isNarrowViewport = window.innerWidth <= 768;

    return isMobileUA || isNarrowViewport;
  }, []);

  const [isMobile, setIsMobile] = useState(checkIsMobile);
  const [isForcedDesktop, setIsForcedDesktop] = useState(() => {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem('trophycoin_force_desktop') === 'true';
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(checkIsMobile());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [checkIsMobile]);

  const toggleDesktopMode = useCallback((force) => {
    const nextState = force !== undefined ? force : !isForcedDesktop;
    if (nextState) {
      localStorage.setItem('trophycoin_force_desktop', 'true');
    } else {
      localStorage.removeItem('trophycoin_force_desktop');
    }
    setIsForcedDesktop(nextState);
    setIsMobile(checkIsMobile());
  }, [isForcedDesktop, checkIsMobile]);

  return {
    isMobile,
    isForcedDesktop,
    toggleDesktopMode,
    switchToDesktop: () => toggleDesktopMode(true),
    switchToMobile: () => toggleDesktopMode(false)
  };
}
